import ContentContainer from "atoms/ContentContainer";
import React from "react";
import { useTranslation } from "react-i18next";
import CustomToolTip from "atoms/CustomToolTip";
import GroupPayDateInfo from "atoms/GroupPayDateInfo";
import { Text } from "native-base";
import styles from "./style";

function shouldRenderCombinedText(t1, t2, t3) {
  const boldText = (
    <Text variant="sm" fontWeight="medium" fontStyle="italic">
      {t2}
    </Text>
  );
  return (
    <>
      {`${t1} `}
      {boldText}
      {` ${t3}`}
    </>
  );
}

const GroupPayDate = () => {
  const { t } = useTranslation("common");
  return (
    <ContentContainer title={t("groupPaydate.title")} paddingTop={4} flex={styles.breakpoints.content}>
      <CustomToolTip
        title={t("groupPaydate.noticeTitle")}
        textContent={[
          t("groupPaydate.noticeOne"),
          shouldRenderCombinedText(
            t("groupPaydate.noticeTwo"),
            t("groupPaydate.noticeFive"),
            t("groupPaydate.noticeFour"),
          ),
          t("groupPaydate.noticeThree"),
        ]}
        containerStyle={{ marginTop: 24 }}
      />
      <GroupPayDateInfo />
    </ContentContainer>
  );
};

export default GroupPayDate;
